var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navigation"},[_c('nav',{staticClass:"navigation__nav"},[_vm._t("nav")],2),_c('div',{staticClass:"navigation__container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }